export { default } from './PageFile.vue'
